<template>
  <el-container style="height: 100vh">
    <el-aside :width="isCollapse ? '64px' : '210px'" style="transition: width 0.3s; background-color: #304156">
      <div style="height: 50px; line-height: 50px; text-align: center">
        <span v-if="!isCollapse" style="color: #fff; font-size: 16px; font-weight: bold">招生管理系统</span>
        <span v-else style="color: #fff; font-size: 16px; font-weight: bold">CDUT</span>
      </div>
      <sidebar :routes="routes" :collapse="isCollapse" />
    </el-aside>
    <el-container>
      <el-header style="height: 50px; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #eee; padding: 0 20px">
        <div style="display: flex; align-items: center">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" style="font-size: 20px; cursor: pointer" @click="toggleCollapse" />
          <el-breadcrumb separator="/" style="margin-left: 20px">
            <el-breadcrumb-item v-for="item in breadcrumbs" :key="item.path">{{ item.meta.title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-dropdown @command="handleCommand">
          <span style="cursor: pointer; display: flex; align-items: center">
            <el-avatar :size="30" :src="avatar || ''" style="margin-right: 8px">
              <i class="el-icon-user-solid" />
            </el-avatar>
            {{ nickname }}
            <i class="el-icon-arrow-down" style="margin-left: 5px" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile">个人中心</el-dropdown-item>
            <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-main style="background-color: #f0f2f5; padding: 20px">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Sidebar from './Sidebar.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  components: {
    Sidebar
  },
  data() {
    return {
      isCollapse: false
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar', 'routes']),
    breadcrumbs() {
      return this.$route.matched.filter(item => item.meta && item.meta.title)
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    handleCommand(command) {
      if (command === 'profile') {
        this.$router.push('/profile')
      } else if (command === 'logout') {
        this.$confirm('确认退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('user/logout').then(() => {
            this.$router.push('/login')
          })
        }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.el-aside {
  overflow: hidden;
}
</style>
